// extracted by mini-css-extract-plugin
export var container = "transition-dashboard-module--container--1f859";
export var header = "transition-dashboard-module--header--59643";
export var reports = "transition-dashboard-module--reports--d2203";